// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"354":"20b34566","776":"49c60703","950":"6ad83b4f"}[chunkId] + ".css";
};